import * as Yup from 'yup';

const createRoundValidation = Yup.object().shape({
  title: Yup.string().required(),
  opened_at: Yup.string().required(),
  closed_at: Yup.string().required(),
});

export default createRoundValidation;
